import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Image as ImageIcon } from "lucide-react";

const when = (iso) => new Date(iso).toLocaleDateString("en", { weekday: "short", month: "short", day: "numeric" });

export default function DayGallery() {
  const [photos, setPhotos] = useState([]);
  const [active, setActive] = useState(null);
  useEffect(() => { api.get("/gallery").then((r) => setPhotos(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-display font-extrabold text-2xl text-navy flex items-center gap-2"><ImageIcon className="w-6 h-6 text-turquoise" /> Day Gallery</h1>
      <p className="text-slate-500">Peek into your explorer's day — photos shared by our team.</p>

      {photos.length === 0 && <p className="text-slate-400 mt-6" data-testid="gallery-empty">No photos yet. When our team shares moments from the day, they'll appear here.</p>}

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mt-6">
        {photos.map((p) => (
          <button key={p.id} onClick={() => setActive(p)} className="text-left rounded-2xl overflow-hidden bg-white border border-slate-200 hover:shadow-lg transition-all" data-testid={`gallery-photo-${p.id}`}>
            <img src={p.url} alt={p.caption} className="w-full h-40 object-cover" />
            <div className="p-2">
              <p className="text-xs font-semibold text-navy truncate">{p.child_name}</p>
              <p className="text-[10px] text-slate-400">{when(p.created_at)}{p.uploader_name ? ` · ${p.uploader_name}` : ""}</p>
              {p.caption && <p className="text-[11px] text-slate-500 mt-0.5 line-clamp-2">{p.caption}</p>}
            </div>
          </button>
        ))}
      </div>

      {active && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" onClick={() => setActive(null)} data-testid="gallery-lightbox">
          <div className="max-w-2xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={active.url} alt={active.caption} className="w-full max-h-[75vh] object-contain rounded-xl" />
            <div className="text-white text-center mt-3">
              <p className="font-semibold">{active.child_name} · {when(active.created_at)}</p>
              {active.caption && <p className="text-white/70 text-sm mt-1">{active.caption}</p>}
              <button onClick={() => setActive(null)} className="mt-3 text-turquoise text-sm" data-testid="gallery-close">Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
